<template>
  <div>
    <v-form v-if="!upd || (!this.can('ROLE_UKD_CREATOR') && isPaid)">
      <p class="text-h5 top40">Поиск УПД</p>

      <v-alert v-if="isUpdSearchError" type="error">
        {{ getUpdSearchErrorMessage }}
      </v-alert>

      <v-alert
        v-if="!this.can('ROLE_UKD_CREATOR') && isPaid && number"
        type="success"
      >
        УПД №{{ searchNumber }} была оплачена
      </v-alert>

      <v-text-field
        v-model="number"
        name="number"
        label="Введите номер УПД"
        type="text"
        clearable
        :rules="[rules.required]"
      ></v-text-field>

      <v-layout align-center justify-center column fill-height>
        <v-progress-circular
          v-if="showLoader"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>
      <v-btn
        block
        x-large
        :disabled="number == null"
        @click="onSearch"
        v-if="!showLoader"
      >
        <v-icon dark>mdi-magnify</v-icon>
        Поиск
      </v-btn>

      <v-btn class="readmore-link top10" color="white" @click="onGoBack">
        <v-icon dark> mdi-arrow-u-left-bottom </v-icon>
        Назад
      </v-btn>
    </v-form>

    <upd v-if="this.can('ROLE_UKD_CREATOR')" :upd="upd" />
    <raw-upd v-else-if="!isPaid && upd" :upd="upd" />
  </div>
</template>

<script>
import Upd from "@/components/Upd";
import RawUpd from "@/components/RawUpd";

export default {
  name: "UpdSearch",
  components: { RawUpd, Upd },
  data: () => ({
    number: "",
    rules: {
      required: (value) => !!value || "Обязательно для заполнения",
      numberRule: (strNumber) => {
        strNumber = strNumber.replaceAll("/", "");
        strNumber = strNumber.replaceAll("\\", "");
        if (!strNumber.trim()) return true;
        if (!isNaN(parseInt(strNumber)) && strNumber >= 0) return true;
        return "Введите число, допускаются символы / и \\";
      },
    },
  }),
  created: function () {
    this.number = this.$route.query.number;
  },
  mounted() {
    this.$store.commit("clearError");
  },
  computed: {
    searchNumber() {
      return this.$store.getters.searchNumber;
    },
    upd() {
      return this.$store.getters.currentUpd;
    },
    isUpdSearchError() {
      return this.$store.getters.updSearchError.code !== null;
    },
    getUpdSearchErrorMessage() {
      return this.$store.getters.updSearchError.message;
    },
    showLoader() {
      return this.$store.getters.showSearchLoader;
    },
    isPaid() {
      return this.$store.getters.isPaid;
    },
  },
  methods: {
    hideAlert() {
      this.$store.commit("clearCanceledGoods");
      this.$store.commit("clearUpd");
    },
    onScan() {
      this.$router.push({ name: "UpdScan" });
    },
    onSearch() {
      this.hideAlert();
      let number = this.number.replace("/", "-");
      this.$store.dispatch("search_upd_by_number", number);
    },
    onGoBack() {
      this.$store.commit("clearCanceledGoods");
      this.$store.commit("clearUpd");
      this.$router.push({ name: "Home" });
    },
  },
};
</script>
